<template>
  <section class="container columns" style="margin: 2% auto">
    <form v-on:submit.prevent="createCrop" class="column is-half">
      <b-field label="Crop Name">
        <b-select
          v-model="newCrop.cropTypeId"
          placeholder="Select a Crop Name"
          :loading="cropTypesLoading == true"
          required
        >
          <option
            v-for="option in cropTypes"
            :value="option._id"
            :key="option._id"
          >
            {{ option.cropTypeName }}
          </option>
        </b-select>
      </b-field>
      <b-field label="Crop Trade Name">
        <b-select
          v-model="newCrop.cropTradeNameId"
          placeholder="Select a Crop Trade Name"
          :loading="tradeNamesLoading == true"
          required
        >
          <option
            v-for="option in tradeNames"
            :value="option._id"
            :key="option._id"
          >
            {{ option.cropTradeName }}
          </option>
        </b-select>
      </b-field>
      <b-field label="Variety Name">
        <b-input v-model="newCrop.varietyName" placeholder required></b-input>
      </b-field>
      <b-field label="Crop Maturity">
        <b-input
          v-model="newCrop.maturity"
          placeholder="put either early, middle or late"
          required
        ></b-input>
      </b-field>
      <b-field label="Number Of Days To Mature">
        <b-input
          v-model="newCrop.numberOfDaysToMature"
          placeholder="Number"
          required
        ></b-input>
      </b-field>

      <div>
        <button class="button is-primary" type="submit">Create</button>
      </div>
    </form>
  </section>
</template>

<script>
import { currencies } from "@/helpers";
import { mapGetters } from "vuex";
export default {
  name: "newCrop",
  data() {
    return {
      tradeNames: [],
      cropTypes: [],
      newCrop: {
        cropTypeId: "",
        varietyName: "",
        cropTradeNameId: "",
        maturity: "",
        numberOfDaysToMature: ""
      }
    };
  },
  created() {
    this.getCropTypes();
    this.getCropTradeNames();
  },
  methods: {
    getCropTypes() {
      this.cropTypesLoading = true;
      this.$store
        .dispatch("getCropTypes")
        .then(cropTypes => {
          this.cropTypesLoading = false;
          if (cropTypes.length >= 0) {
            this.cropTypes = cropTypes;
          } else {
            this.$toasted.global.error("Crop Types not found.");
          }
        })
        .catch(e => {
          this.cropTypesLoading = false;
          console.log("Exception when getting Crop Types", e);
          this.$toasted.global.error("Failed to Crop Types");
        });
    },
    getCropTradeNames() {
      this.tradeNamesLoading = true;
      this.$store
        .dispatch("getCropTradeNames")
        .then(tradeNames => {
          this.tradeNamesLoading = false;
          if (tradeNames.length >= 0) {
            this.tradeNames = tradeNames;
          } else {
            this.$toasted.global.error("Crop Trade Names not found.");
          }
        })
        .catch(e => {
          this.tradeNamesLoading = false;
          console.log("Exception when getting Crop Trade Names", e);
          this.$toasted.global.error("Failed to Crop Trade Names");
        });
    },

    createCrop() {
      const loading = this.$loading.open();

      this.$store
        .dispatch("createCrop", this.newCrop)
        .then(newCrop => {
          loading.close();
          this.$router.push({ cropName: "Crop Names" });
          this.$toasted.global.success("Crop Successfully Created!");
        })
        .catch(e => {
          console.log("Exception when creating new crop", e);
          loading.close();
          this.$toasted.global.error("Failed to create crop .");
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/CropManager/NewCrop.vue